import { Match, Switch } from 'solid-js';
import { Poster } from 'Shared/frontend/Poster';
import { PhotoPoster,PhotoPosterDimensions } from 'Shared/frontend/eventPosters/PhotoPoster';
import { SuppliedPoster } from 'Shared/frontend/eventPosters/SuppliedPoster';
import { ImageSchema } from 'Shared/model/basic';


interface ISpecialsPoster {
	tagline?: string;
	moreInfo?: string;
	imageType: 'photoPoster' | 'suppliedPoster';
	image: ImageSchema;
	imageDimensions: PhotoPosterDimensions;
}


export function SpecialsPoster(P:ISpecialsPoster)
{
//FIXME photo = photoPoster
//FIXME poster = suppliedPoster

	return (
		<Poster {...P}>
			<Switch>
				<Match when={P.imageType == 'photoPoster' || P.imageType == 'photo'}>
					<PhotoPoster {...P} folder='Special-image' size='medium' />
				</Match>
				<Match when={P.imageType == 'suppliedPoster' || P.imageType == 'poster'}>
					<SuppliedPoster {...P} folder='Special-image' size='medium' />
				</Match>
			</Switch>
		</Poster>
	);
}

